import { createNewSessionIfNeeded } from '@src/quince-site-common/src/trackers/initializeAnalytics'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import { getFromLocalStorageWithExpiry } from '@src/quince-site-common/src/utils/getFromLocalStorageWithExpiry'
import { getlbUserId, createLastBrandUserId } from '@src/quince-site-common/src/utils/getlb-user-id'
import { setInLocalStorageWithExpiry } from '@src/quince-site-common/src/utils/setInLocalStorageWithExpiry'
import { getCookie } from '@src/quince-site-integrated/src/utils'

export const validateLbUserId = () => {
  createLastBrandUserId() // Create if needed.
  const lbUserId = getlbUserId()
  if (lbUserId && !getFromLocalStorageWithExpiry(ANALYTIC_COOKIES.LB_USER_ID, false)) {
    setInLocalStorageWithExpiry(ANALYTIC_COOKIES.LB_USER_ID, lbUserId)
  }
  return lbUserId
}

let isNewSession = false
const lastSessionIdKey = 'last_session_id'

export const validateSessionId = () => {
  createNewSessionIfNeeded()
  const sessionIdFromCookie = getCookie(ANALYTIC_COOKIES.SESSION_ID)
  if (!sessionIdFromCookie) {
    return null
  }
  // eslint-disable-next-line @quince/no-direct-localstorage
  const lastSessionIdFromLocalStorage = localStorage.getItem(lastSessionIdKey)
  if (lastSessionIdFromLocalStorage !== sessionIdFromCookie) {
    isNewSession = true
  }
  // eslint-disable-next-line @quince/no-direct-localstorage
  localStorage.setItem(lastSessionIdKey, sessionIdFromCookie)
  setInLocalStorageWithExpiry(ANALYTIC_COOKIES.SESSION_ID, sessionIdFromCookie, 120)
  return sessionIdFromCookie
}

export const executeOnceIfSessionIsNew = (task: () => void) => {
  if (isNewSession) {
    isNewSession = false
    try {
      task()
    } catch (error) {
      console.error('Error executing task for new session:', error)
    }
  }
}
